<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <el-popover trigger="click" :content="report.title" placement="top-start">
          <h4 slot="reference" class="text-nowrap" style="line-height: 35px; display: block">
            <el-tag style="margin-right: 8px" title="未读 / 已读" size="mini" :type="report.unreadCount? 'warning': 'success'"><span :class="clz"></span> {{report.unreadCount}} / {{report.count}}</el-tag>
            <el-tag style="margin-right: 8px" size="mini" type="info"><span class="el-icon-star-on"></span>{{report.suggestCount}}</el-tag>
            <el-tag style="margin-right: 8px" size="mini" type="warning"><span class="el-icon-delete"></span>{{report.unusedCount}}</el-tag>
            {{ report.title }}
          </h4>
        </el-popover>
      </div>
      <div class="help-text">
        <span class="el-icon-timer"></span>创建时间：{{ report.createDate }}
        <el-button size="mini" class="float-right" type="text" icon="el-icon-search" @click="read">查看</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import DailyReport from "@/models/DailyReport";

export default {
  name: "DailyReportNav",
  props: {
    report: DailyReport
  },
  computed: {
    clz() {
      if (this.report.unreadCount <= 0) {
        return "el-icon-reading color-green"
      }
      return "el-icon-message color-orange"
    }
  },
  methods: {
    read() {
      this.$emit('read', this.report)
    }
  }
}
</script>

<style scoped>

</style>
